import request from '@/utils/request'

export function getOrderRooms (data) {
  return request({
    url: '/api/admin/order-rooms',
    method: 'post',
    data: data
  })
}
